import { render, staticRenderFns } from "./TransferNotification.vue?vue&type=template&id=74c8ca74&scoped=true"
import script from "./TransferNotification.vue?vue&type=script&lang=js"
export * from "./TransferNotification.vue?vue&type=script&lang=js"
import style0 from "./TransferNotification.vue?vue&type=style&index=0&id=74c8ca74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8ca74",
  null
  
)

export default component.exports